// extracted by mini-css-extract-plugin
export default {"wrapper":"QantityCell_wrapper__saytT","counter":"QantityCell_counter__YkC-3","counter_disabled":"QantityCell_counter_disabled__4jP5I"};